const baseUrl = process.env.PUBLIC_URL
export const default_skin = "6"

export const popupType = {
    DELETE: "DELETE",
    LOGOUT: "LOGOUT"
}

export const formType = {
    LOGIN_CANDIDATE: "LOGIN_CANDIDATE",
    LOGIN_EMPLOYER: "LOGIN_EMPLOYER"
}

export function publicUrlFor(path) {
    return baseUrl + "/assets/" + path;
}

export function loadScript(src, fromPublic) {

    return new Promise(function (resolve, reject) {
        var script = document.createElement('script');

        script.src = (
            fromPublic === undefined ||
            fromPublic == null ||
            fromPublic
        ) ? publicUrlFor(src) : src;

        script.addEventListener('load', function () {
            resolve();
        });
        script.addEventListener('error', function (e) {
            reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
    })
};

export function setMenuActive(currentpath, path) {
    return (currentpath === path) ? "active": "";
}

export function applyDefaultSkinStyle() {
    updateSkinStyle(default_skin, true, false);
}

export function updateSkinStyle(skin, headerLogoLight, footerLogoLight) {
    var _skin_style = document.getElementById("skin_style");
    var _skin_header_logo = document.getElementById("skin_header_logo");
    var _skin_header_logo_light = document.getElementById("skin_header_logo_light");
    var _skin_footer_dark_logo = document.getElementById("skin_footer_dark_logo");
    var _skin_footer_light_logo = document.getElementById("skin_footer_light_logo");
    var _skin_page_logo = document.getElementById("skin_page_logo");
    var _skin_maintain_logo = document.getElementById("skin_maintain_logo");
    var _skin_header_inner_logo_12 = document.getElementById("skin_header_inner_logo_12");
    var _skin_header_inner_logo_15 = document.getElementById("skin_header_inner_logo_15");
    const _logo = publicUrlFor('images/logo.svg');
    const _logo_light = publicUrlFor('images/logo-light-3.png');
    const _logo_white = publicUrlFor('images/logo-white.png');

    if (_skin_style)
        _skin_style.href = publicUrlFor('css/skins-type/skin-' + skin + '.css');

    if (_skin_header_logo)
        _skin_header_logo.src = _logo;

    if (_skin_header_logo_light) // initially light, on switcher change => it should change
        _skin_header_logo_light.src = headerLogoLight ? _logo_light : _logo;

    if (_skin_footer_dark_logo)
        _skin_footer_dark_logo.src = footerLogoLight ? _logo_white : publicUrlFor('images/logo.svg');

    if (_skin_footer_light_logo)
        _skin_footer_light_logo.src = _logo;

    if (_skin_page_logo)
        _skin_page_logo.src = _logo;

    if (_skin_maintain_logo)
        _skin_maintain_logo.src = publicUrlFor('images/skins-logo/mainten-logo-' + skin + '.png');

    if (_skin_header_inner_logo_12)
        _skin_header_inner_logo_12.src = publicUrlFor('images/skins-logo/logo-all.png');

    if (_skin_header_inner_logo_15)
        _skin_header_inner_logo_15.src = publicUrlFor('images/skins-logo/logo-white.png');
}

export const enLangTranslation = {
    menu: {
        home: "Home",
        expertise: "Our Expertise",
        about: "About us",
        process: "Work Process",
        vacancies: "Vacancies",
        reviews: "Testimonials",
    },

    section1: {
        headline1: "Your Dream Job",
        headline2: " Just a Step Away",
        subtitle: "Discover job opportunities that match your skills and ambitions. InOvation connects you with top employers, helping you take the next step in your professional journey.",
        stats: {
            partners: "Partnered Companies",
            hires: "Successful Placements",
            countries: "Job Opportunities Across Countries",
        },
        cta: "Get Started",
    },

    section2: {
        title: "Our Expertise",
        subtitle: "Explore Career Opportunities in Leading Industries",
        description:
            "Discover the right job for your skills and ambitions across multiple thriving sectors. Our expertise spans a variety of industries, connecting you with top employers and career-defining roles.",
        industries: {
            it: {
                title: "IT & Software Development",
                description:
                    "From innovative software engineering to advanced cybersecurity solutions, we help professionals in software development, testing, DevOps, analytics, and cybersecurity find the right opportunities. Whether you're a coder, data expert, or security specialist, we have a place for you in the tech industry.",
            },
            marketing: {
                title: "Marketing & Advertisement",
                description:
                    "Join the fast-paced world of digital marketing. We specialize in roles across Social Media Management (SMM), Pay-Per-Click (PPC) advertising, Search Engine Optimization (SEO), and Media Buying. Whether you're a strategist, analyst, or creative thinker, we connect you with leading brands to drive impactful campaigns.",
            },
            finance: {
                title: "Finance & Investment",
                description:
                    "Numbers drive business success, and so do finance professionals. We offer career opportunities in accounting, financial analysis, and trading, helping experts manage assets, analyze markets, and optimize financial strategies in top firms.",
            },
            operations: {
                title: "Operational & Business Management",
                description:
                    "Behind every great company is a strong operational backbone. Whether you're in HR, recruitment, or administration, we connect professionals with leadership roles that keep businesses running smoothly and efficiently.",
            },
        },
    },

    section3: {
        title: "Recognized by ",
        subtitle: "10+ companies",
    },

    section4: {
        title: "About Us",
        headline: "Connecting Businesses with Top Talents Worldwide",
        body: [
            "We are a passionate recruitment agency dedicated to helping businesses find exceptional professionals across Ukraine and Europe. If you're looking for talented individuals to strengthen your team, we're here to make it happen.",
            "Our team of expert recruiters and sourcers knows exactly where to find the best candidates and how to make the hiring process fast, seamless, and effective.",
            "We specialize in a variety of industries, including IT, Marketing & Advertising, Finance, and Operational Management, ensuring that businesses connect with professionals who drive success.",
            "But we do more than just fill positions—we find people who will elevate your business and help it grow.",
        ],
        principles: {
            title: "Our Core Principles:",
            transparency: "Transparency – Open communication and honest feedback at every step.",
            resultOriented: "Results-Driven Approach – Quality over quantity, always focusing on efficiency.",
            partnership: "True Partnership – We work as an extension of your team, not just an external service.",
            cta: "Let’s build the perfect team together!",
        },
    },

    section5: {
        title: "Work Process",
        headline: "How We Work",
        steps: [
            {
                step: "1",
                title: "Tell Us Your Hiring Needs",
                description:
                    "We start by understanding your business, culture, and hiring requirements. Our team works closely with you to define the ideal candidate profile and create a strategy to find the best talent.",
            },
            {
                step: "2",
                title: "Finding & Vetting Top Talent",
                description:
                    "Using our extensive network and advanced sourcing techniques, we identify, screen, and evaluate top candidates. We handle the initial interviews, skill assessments, and background checks to ensure only the best professionals reach you.",
            },
            {
                step: "3",
                title: "Seamless Hiring & Onboarding",
                description:
                    "Once we find the perfect match, we facilitate the hiring process, negotiations, and onboarding support. Our goal is to make recruitment effortless, so you can focus on growing your business with the right team.",
            },
        ],
    },

    section6: {
        headline: "Exclusive Job Offers",
        subtitle: "Quickly connect with top-tier candidates.",
        jobs: [
            {
                title: "Recruiter",
                description:
                    "If you love discovering top talent, understand modern recruitment strategies, and strive to improve your skills, this position is for you. You will take on a crucial mission—attracting professionals who will help our company grow and achieve new heights. Join us and unlock your potential with our team!",
            },
            {
                title: "Management Accounting Specialist",
                description:
                    "A Management Accounting Specialist is detail-oriented, responsible, and capable of handling large volumes of data. If you're eager to work with a team that values your expertise and experience—let’s connect! 🚀",
            },
            {
                title: "HR Admin",
                description:
                    "HR Admin thrives on order, detail, and structure. If you love Excel, HR processes, and keeping documentation audit-ready—this role is for you. Join a team that values precision, flexibility, and growth.",
            },
        ],
        fulltime: "Fulltime",
        button: "Apply Job",
    },

    section7: {
        title: "Testimonials",
        headline: "What Our Clients Say About Us",
        description:
            "At InOvation, we focus on your success with personalized recruitment solutions tailored to your industry and goals. We carefully vet candidates and streamline hiring, ensuring you build a high-performing team effortlessly. Our commitment to transparency, efficiency, and partnership has earned the trust of businesses across sectors.",
        cta: "But don’t just take our word for it—hear from our satisfied clients!",
        testimonials: [
            {
                text: "Exceptional recruitment services! They provided us with top-tier IT specialists quickly, ensuring a smooth hiring process and seamless integration into our team.",
                author: "Andriy Melnyk",
                position: "HR Director",
            },
            {
                text: "A highly professional approach! They understood our hiring needs and delivered skilled marketing experts who perfectly fit our company culture.",
                author: "Sophie Laurent",
                position: "Talent Acquisition Manager",
            },
            {
                text: "Their expertise in finance recruitment is unmatched. We hired outstanding analysts and traders, improving our operational efficiency significantly.",
                author: "Maksym Kovalenko",
                position: "CEO",
            },
            {
                text: "Reliable and results-driven! They helped us fill key administrative roles, saving us time while ensuring top-quality candidates.",
                author: "Luca Romano",
                position: "Operations Manager",
            },
            {
                text: "Finding qualified cybersecurity professionals is challenging, but this agency consistently delivers the best candidates who meet our high standards.",
                author: "Kateryna Dmytrenko",
                position: "Head of HR",
            },
            {
                text: "They go beyond just recruitment. Their strategic hiring solutions have helped us scale our team with the right people at the right time.",
                author: "Thomas Bauer",
                position: "Managing Director",
            },
        ],
    },

    vacancies: [
        {
            title: "Recruiter",
            who: {
                title: "Who Are We Looking For?",
                description:
                    "If you are passionate about finding top talent, understand modern recruitment strategies, and strive to refine your skills, this role is for you. You will take on a key mission—attracting specialists who will help our company grow and reach new heights. Join us and unlock your potential with our team!",
            },
            client: {
                title: "Client: ",
                description:
                    "A group of IT companies specializing in digital product development, software solutions, and digital advertising services for external clients. The company fosters an environment where every employee can work efficiently while continuously developing, receiving support, and maintaining a healthy work-life balance. They believe in the Kaizen philosophy—constant improvement—and teamwork, where new ideas bring unique experiences and drive personal growth.",
            },
            responsibilities: {
                title: "Key Responsibilities:",
                items: [
                    "Sourcing and recruiting candidates (3-5 vacancies per month)",
                    "Conducting initial screening interviews",
                    "Communicating with internal stakeholders to define job requirements",
                    "Organizing final interviews",
                    "Posting job openings across various hiring platforms and managing candidate attraction channels",
                    "Maintaining the candidate database and ensuring a high level of communication at every stage",
                    "Analyzing the labor market to assess the competitiveness of job offers",
                ],
            },
            requirements: {
                title: "Candidate Requirements:",
                items: [
                    "At least 1 year of experience in recruitment or HR",
                    "Knowledge of modern recruitment tools and professional platforms",
                    "Understanding of the full recruitment cycle",
                    "Ability to work in a fast-paced environment while managing multiple tasks",
                    "Strong communication skills and the ability to build trust-based relationships",
                    "English proficiency at Intermediate level or higher is a plus",
                ],
            },
            offer: {
                title: "What We Offer:",
                items: [
                    "Flexible work schedule and remote work options",
                    "Paid sick leave and annual vacation",
                    "Bonus and compensation programs",
                    "Reimbursement for training and professional development",
                    "Medical insurance",
                    "A friendly team and full support at every stage of your work",
                ],
            },
            stages: {
                title: "Selection Process:",
                subtitle: "HR Interview ➡ Test Task ➡ Final Interview with Team Leader ➡ Offer 🎉",
            },
        },
        {
            title: "Management Accounting Specialist",
            who: {
                title: "Who Are We Looking For?",
                description: "A Management Accounting Specialist who is detail-oriented, responsible, and capable of handling large volumes of information. If you are eager to work with a team that values your knowledge and experience—let’s connect! 🚀",
            },
            client: {
                title: "Client: ",
                description: "A company that helps entrepreneurs eliminate accounting routine tasks and focus on what truly matters. They provide professional, fast, and client-focused financial management services, ensuring structured and efficient accounting.",
            },
            values: {
                title: "Core Values & Work Principles:",
                items: [
                    "Simplicity – We turn complexity into clarity",
                    "Professionalism – We work with responsibility and high standards",
                    "Growth – We learn, develop, and share knowledge"
                ]
            },
            responsibilities: {
                title: "Key Responsibilities:",
                items: [
                    "Ensuring accuracy in payment processing and transactions across budget categories, projects, and accounting records",
                    "Reconciling operations in the system with bank statements, analyzing balances and turnovers in company accounts",
                    "Preparing analytical reports on projects and business directions",
                    "Verifying the correct balance representation of assets, travel expenses, accountable funds, and supplier refunds"
                ]
            },
            requirements: {
                title: "Candidate Requirements:",
                items: [
                    "3-5 years of experience as an accountant, financial controller, or auditor (experience in international or audit firms is a plus)",
                    "Higher education in economics (ACCA, CAP/CIPA, CIMA certification is an advantage)",
                    "Strong knowledge of financial and management accounting, including reporting structure",
                    "Proficiency in accounting principles, control systems, and audit processes",
                    "Experience in financial transaction analysis, data reconciliation, and ensuring correct balance representation",
                    "Ability to work with large datasets and databases",
                    "Advanced Excel proficiency",
                    "Analytical mindset with strong attention to detail",
                    "Passion for financial management, understanding it as a key service function for effective decision-making"
                ]
            },
            benefits: {
                title: "What We Offer:",
                items: [
                    "Flexible work schedule and remote work options",
                    "Paid sick leave and annual vacation",
                    "Bonus and compensation programs",
                    "Reimbursement for professional training",
                    "Medical insurance",
                    "A supportive and friendly team"
                ]
            },
            stages: {
                title: "Selection Process:",
                subtitle: "HR Screening ➡ Interview with Hiring Manager ➡ Final Interview with CFO ➡ Offer 🎉"
            }
        },
        {
            title: "HR Admin",
            who: {
                title: "Who Are We Looking For?",
                description: "We’re looking for an HR Admin who loves order more than morning coffee. If Excel is your best friend, and words like “employee file” and “HR order” spark professional joy instead of panic — we’ve got a spot for you. Your superpower is keeping HR records so perfectly organized that even audits applaud? Then you're exactly who we need.",
            },
            responsibilities: {
                title: "What You’ll Be Doing:",
                items: [
                    "Managing personnel records for the company and its departments",
                    "Full-cycle HR documentation in accordance with Ukrainian labor law",
                    "Creating and maintaining employee personal files",
                    "Maintaining and storing employment record books",
                    "Tracking and managing employee vacation records",
                    "Archiving personal files"
                ]
            },
            requirements: {
                title: "What Matters to Us:",
                items: [
                    "At least 1 year of experience in HR administration",
                    "Knowledge of Ukrainian labor legislation",
                    "Experience working with HR documentation",
                    "Confident user of Excel and BAF (BAS) systems",
                    "Attention to detail, responsibility, and structured thinking — must-haves in HR paperwork",
                    "Ability to work with confidential data and comply with GDPR/internal company policies",
                    "English language proficiency at B1 level"
                ]
            },
            benefits: {
                title: "What You’ll Get in Return:",
                items: [
                    "Hybrid work format with the flexibility to work from home",
                    "Minimal bureaucracy, maximum freedom",
                    "Opportunities for professional development",
                    "Bonus programs (language learning, sports, mental health support, etc.)",
                    "Compensation for education and training expenses",
                    "Medical insurance"
                ]
            },
            stages: {
                title: "Selection Process:",
                subtitle: "HR Screening ➡ Interview with Hiring Manager ➡ Final Interview with CFO ➡ Offer 🎉",
            }
        }
    ],

    jobInfo: {
      title: "Job Information",
      date: "Date Posted",
      dateValue: "April 22, 2023",
      location: "Location",
      locationValue: "Kyiv, Ukraine",
      experience: "Experience",
      experienceValue: "3 years",
      job: "Job Title",
    },

    contactForm: {
        title: "Get in Touch with Us",
        subtitle: "Have questions or need assistance? Reach out to us, and our team will respond as soon as possible. We’re here to help!",
        name: "Full Name",
        email: "Email",
        date: "Date of Birth",
        subject: "Subject",
        message: "Message",
        upload: "Upload File",
        submit: "Submit",
    },

    footer: {
        description:
            "We are a professional recruitment agency dedicated to connecting businesses with top talent. We streamline the hiring process, ensuring the right fit for every role.",
        linksTitle: "Quick Links",
        links: {
            home: "Home",
            expertise: "Our Expertise",
            about: "About us",
            process: "Work Process",
            vacancies: "Vacancies",
            reviews: "Testimonials",
        },
        contactsTitle: "Contacts",
    },
};

export const uaLangTranslation = {
    menu: {
        home: "Головна",
        expertise: "Наша експертиза",
        about: "Про нас",
        process: "Робочий процес",
        vacancies: "Вакансії",
        reviews: "Відгуки",
    },

    section1: {
        headline1: "Твоя робота мрії",
        headline2: "— на відстані одного кроку",
        subtitle: "Знаходь вакансії, що відповідають твоїм навичкам і амбіціям. InOvation з'єднує тебе з провідними роботодавцями, допомагаючи зробити наступний крок у кар’єрі.",
        stats: {
            partners: "Компаній-партнерів",
            hires: "Успішних працевлаштувань",
            countries: "Вакансій у різних країнах",
        },
        cta: "Почати",
    },

    section2: {
        title: "Наша експертиза",
        subtitle: "Досліджуй кар’єрні можливості в провідних індустріях",
        description:
            "Знаходь роботу, що відповідає твоїм навичкам і амбіціям у різних перспективних галузях. Ми спеціалізуємось на підборі фахівців для широкого спектру індустрій, з'єднуючи тебе з провідними роботодавцями та посадами що формують кар’єру.",
        industries: {
            it: {
                title: "ІТ & Розробка ПЗ",
                description:
                    "Від інноваційної розробки ПЗ до передових рішень у сфері кібербезпеки — ми допомагаємо професіоналам у сферах розробки, тестування, DevOps, аналітики та кібербезпеки знайти найкращі можливості. Якщо ти розробник, аналітик чи спеціаліст із захисту даних — ми маємо вакансії саме для тебе.",
            },
            marketing: {
                title: "Маркетинг і Реклама",
                description:
                    "Приєднуйся до динамічного світу цифрового маркетингу. Ми спеціалізуємося на підборі фахівців у сфері SMM, PPC, SEO та медіабаїнгу. Якщо ти стратег, аналітик або креативник — допоможемо знайти роботу у провідних брендах, щоб створювати ефективні кампанії.",
            },
            finance: {
                title: "Фінанси та Інвестиції",
                description:
                    "Цифри рухають бізнес — і фінансові фахівці теж. Ми пропонуємо вакансії у сфері бухгалтерії, фінансового аналізу та трейдингу, допомагаючи експертам управляти активами, аналізувати ринки та оптимізувати фінансові стратегії.",
            },
            operations: {
                title: "Операційне та Бізнес-Управління",
                description:
                    "За кожною успішною компанією стоїть надійна операційна база. Незалежно від того, чи ти HR, рекрутер або адміністратор — ми знайдемо для тебе керівну роль, яка забезпечить ефективну роботу бізнесу.",
            },
        },
    },

    section3: {
        title: "Понад",
        subtitle: " 10 компаній обрали нас",
    },

    section4: {
        title: "Про нас",
        headline: "Об'єднуємо бізнес із топ-фахівцями по всій Європі",
        body: [
            "Ми — амбітне рекрутингове агентство, що допомагає бізнесу знаходити талановитих спеціалістів в Україні та Європі. Шукаєте сильних людей для своєї команди? Ми допоможемо вам їх знайти.",
            "Наша команда досвідчених рекрутерів і сорсерів знає, де шукати найкращих кандидатів і як зробити процес найму швидким, зручним та ефективним.",
            "Ми працюємо з різними сферами — IT, маркетинг і реклама, фінанси, операційне управління — і допомагаємо бізнесу знаходити фахівців, які справді приносять результат.",
            "Але ми не просто закриваємо вакансії — ми знаходимо людей, які виведуть ваш бізнес на новий рівень.",
        ],
        principles: {
            title: "Наші принципи",
            transparency: "Прозорість — відкрита комунікація та чесний фідбек на всіх етапах.",
            resultOriented: "Орієнтованість на результат — якість важливіша за кількість, завжди діємо ефективно.",
            partnership: "Партнерство — працюємо як частина вашої команди, а не як зовнішній підрядник.",
            cta: "Давайте створимо ідеальну команду разом!",
        },
    },

    section5: {
        title: "Робочий процес",
        headline: "Як ми працюємо",
        steps: [
            {
                step: "1",
                title: "Розкажіть про ваші потреби в наймі",
                description:
                    "Ми починаємо зі знайомства з вашим бізнесом, корпоративною культурою та вимогами до кандидатів. Команда тісно співпрацює з вами, щоб визначити ідеальний профіль фахівця та сформувати ефективну стратегію пошуку талантів.",
            },
            {
                step: "2",
                title: "Пошук і відбір кращих кандидатів",
                description:
                    "Використовуючи широку мережу контактів і сучасні інструменти сорсингу, ми шукаємо, перевіряємо та оцінюємо кандидатів. Проводимо первинні інтерв’ю, оцінювання навичок і перевірку бекграунду — до вас потрапляють лише найкращі професіонали.",
            },
            {
                step: "3",
                title: "Гармонійне працевлаштування та адаптація",
                description:
                    "Коли ідеальний кандидат знайдений, ми беремо на себе організацію процесу найму, переговорів і підтримку під час онбордингу. Наша мета — зробити рекрутинг максимально простим, щоб ви могли зосередитися на розвитку бізнесу з правильною командою.",
            },
        ],
    },

    section6: {
        headline: "Ексклюзивні вакансії",
        subtitle: "Оперативно залучайте кращих спеціалістів.",
        jobs: [
            {
                title: "Рекрутер",
                description:
                    "Якщо ти обожнюєш знаходити таланти, розумієш сучасні підходи до рекрутингу та прагнеш розвиватися — ця вакансія саме для тебе. На тебе чекає важлива місія — залучення фахівців, які допоможуть компанії зростати й досягати нових висот. Приєднуйся до нас та розкрий свій потенціал у нашій команді!",
            },
            {
                title: "Спеціаліст з управлінського обліку",
                description:
                    "Спеціаліст з управлінського обліку — це уважність до деталей, відповідальність та вміння працювати з великими обсягами даних. Якщо тобі цікаво бути частиною команди, яка цінує твій досвід і знання — давай знайомитись! 🚀",
            },
            {
                title: "HR-адміністратор",
                description:
                    "HR-адміністратор — обожнює порядок, деталі та системність. Якщо Excel — твоя стихія, а кадрова документація викликає радість — ця вакансія для тебе. Приєднуйся до команди, яка цінує точність, гнучкість і розвиток.",
            },
        ],
        fulltime: "Повний робочий день",
        button: "Відгукнутись",
    },

    section7: {
        title: "Відгуки",
        headline: "Що про нас говорять клієнти",
        description:
            "В InOvation ми зосереджені на вашому успіху, надаючи індивідуальні рекрутингові рішення, адаптовані до вашої галузі та цілей. Ми ретельно перевіряємо кандидатів і оптимізуємо процес найму, щоб ви могли без зусиль зібрати ефективну команду. Наша відданість прозорості, ефективності та партнерству здобула довіру бізнесів з різних сфер.",
        cta: "Але не вірте лише нам — послухайте, що кажуть наші задоволені клієнти:",
        testimonials: [
            {
                text: "Винятковий рекрутинговий сервіс! Вони швидко підібрали першокласних IT-спеціалістів, забезпечивши легкий процес найму та інтеграції.",
                author: "Андрій Мельник",
                position: "HR-директор",
            },
            {
                text: "Надзвичайно професійний підхід! Команда докладно зрозуміла наші потреби й підібрала маркетологів, які ідеально вписались у нашу культуру.",
                author: "Софі Лоран",
                position: "HR-менеджер",
            },
            {
                text: "Експертиза цієї компанії у фінансовому рекрутингу — безцінна. Ми знайшли аналітиків і трейдерів, які суттєво підвищили ефективність бізнесу.",
                author: "Максим Коваленко",
                position: "CEO",
            },
            {
                text: "Надійні та орієнтовані на результат! Швидко закрили ключові адміністративні позиції, заощадивши наш час і ресурси.",
                author: "Лука Романо",
                position: "Операційний менеджер",
            },
            {
                text: "Знайти кваліфікованих спеціалістів з кібербезпеки непросто, але ця агенція стабільно забезпечує топових кандидатів.",
                author: "Катерина Дмитренко",
                position: "Керівник HR-відділу",
            },
            {
                text: "Вони роблять більше, ніж просто рекрутинг. Їхні стратегічні рішення допомогли нам масштабувати команду у потрібний момент.",
                author: "Томас Бауер",
                position: "Виконавчий директор",
            },
        ],
    },

    vacancies: [
        {
            id: "recruiter",
            title: "Рекрутер",
            date: "22.04.2023",
            location: "Київ, Україна",
            experience: "3 роки",
            who: {
                title: "Кого шукаємо?",
                description:
                    "Рекрутера — якщо ти любиш знаходити найкращих людей, розумієшся на сучасних підходах до пошуку персоналу та прагнеш вдосконалювати власні навички, ця вакансія саме для тебе. Тобі буде довірено важливу місію — залучення фахівців, які допоможуть нашій компанії зростати й досягати нових висот. Приєднуйся до нас та розкрий свій потенціал разом із нами.",
            },
            client: {
                title: "Клієнт: ",
                description:
                    "Група компаній ІТ-холдингу, який займається розробкою digital-продуктів та програмного забезпечення, а також надає послуги digital реклами для зовнішніх клієнтів. Компанія створює середовище, де кожен співробітник може не тільки ефективно працювати, але й розвиватися, отримуючи підтримку та цінуючи власний баланс між роботою та особистим життям. Компанія вірить в силу кайдзен — постійне вдосконалення, а також у командну роботу, де нові рішення приносять унікальний досвід та сприяють особистісному росту.",
            },
            responsibilities: {
                title: "Основні обов'язки",
                items: [
                    "Пошук та підбір персоналу (3–5 вакансій щомісяця)",
                    "Проведення первинних скринінгів з кандидатами",
                    "Комунікація з внутрішнім замовником для визначення вимог до вакансій",
                    "Організація фінальних інтерв’ю",
                    "Розміщення вакансій на різних платформах з пошуку та управління каналами залучення кандидатів",
                    "Ведення бази кандидатів і забезпечення високого рівня комунікації на кожному етапі",
                    "Проведення аналізу ринку праці для оцінки конкурентності пропозицій",
                ],
            },
            requirements: {
                title: "Вимоги до кандидата",
                items: [
                    "Досвід роботи рекрутером/HR від 1 року",
                    "Вміння працювати з сучасними інструментами рекрутингу та професійними платформами",
                    "Розуміння повного циклу підбору персоналу",
                    "Здатність працювати у швидкому темпі та одночасно вести кілька завдань",
                    "Високі комунікативні навички та вміння встановлювати довірливі стосунки",
                    "Рівень англійської мови не нижче Intermediate буде перевагою",
                ],
            },
            offer: {
                title: "Що ми пропонуємо",
                items: [
                    "Гнучкий графік роботи та можливість працювати віддалено",
                    "Оплачувані лікарняні та щорічна відпустка",
                    "Програму бонусів та компенсацій",
                    "Компенсацію витрат на навчання",
                    "Медичне страхування",
                    "Дружню команду та підтримку на всіх етапах роботи",
                ],
            },
            stages: {
                title: "Етапи відбору",
                subtitle: "Інтерв'ю з HR ➡ Тестове завдання ➡ Фінальна співбесіда з TL ➡ Offer 🎉",
            },
        },
        {
            id: "accounting-specialist",
            title: "Спеціаліст з управлінського обліку",
            date: "22.04.2023",
            location: "Київ, Україна",
            experience: "3 роки",
            who: {
                title: "Кого шукаємо?",
                description: "Спеціаліст з управлінського обліку — уважний до деталей, відповідальний та готовий до обробки великих обʼємів інформації. Якщо тобі цікаво працювати в команді, яка цінує твої знання та досвід — давай знайомитися 🚀",
            },
            client: {
                title: "Клієнт: ",
                description: "Команда, яка допомагає підприємцям забути про бухгалтерську рутину й зосередитися на тому, що справді важливо. Ведуть бухгалтерію, розбираються у фінансах, структурують облік — і роблять це професійно, швидко та з турботою про клієнтів.",
            },
            values: {
                title: "Цінності та принципи роботи:",
                items: [
                    "Простота — перетворюємо складне на зрозуміле",
                    "Професіоналізм — працюємо якісно й відповідально",
                    "Розвиток — вчимося, зростаємо та ділимося знаннями"
                ]
            },
            responsibilities: {
                title: "Основні обов'язки:",
                items: [
                    "Контроль правильності заповнення платежів та операцій щодо бюджетних категорій, проектів та рахунків обліку",
                    "Звірка операцій у системі з виписками, аналіз оборотів та залишків на рахунках компанії",
                    "Підготовка аналітичної інформації щодо проєктів і напрямів",
                    "Перевірка правильності відображення в балансі: основних засобів, витрат на відрядження, коштів, виданих під звіт, повернень від постачальників"
                ]
            },
            requirements: {
                title: "Вимоги до кандидата:",
                items: [
                    "Досвід 3–5 років роботи бухгалтером, фінансовим контролером або аудитором (міжнародні/аудиторські компанії — плюс)",
                    "Вища економічна освіта; перевага — ACCA, CAP/CIPA, CIMA",
                    "Знання фінансового та управлінського обліку, управлінської звітності",
                    "Знання принципів контролю, аудиту, бухгалтерського обліку",
                    "Володіння аналізом фінансових операцій, звірка даних",
                    "Досвід роботи з базами даних, обробка великих масивів",
                    "Впевнене володіння Excel",
                    "Уважність до деталей, аналітичне мислення",
                    "Розуміння обліку як сервісної функції для прийняття рішень"
                ]
            },
            benefits: {
                title: "Що ми пропонуємо:",
                items: [
                    "Гнучкий графік роботи та можливість працювати віддалено",
                    "Оплачувані лікарняні та щорічна відпустка",
                    "Програма бонусів та компенсацій",
                    "Компенсація витрат на навчання",
                    "Медичне страхування",
                    "Дружня команда та підтримка на всіх етапах роботи"
                ]
            },
            stages: {
                title: "Етапи відбору",
                subtitle: "Інтерв'ю з HR ➡ Тестове завдання ➡ Фінальна співбесіда з CFO ➡ Offer 🎉",
            },
        },
        {
            id: "hr-admin",
            title: "HR Admin",
            date: "22.04.2023",
            location: "Київ, Україна",
            experience: "1 рік",
            who: {
                title: "Кого шукаємо?",
                description: "Ми шукаємо в команду HR Admin, який обожнює порядок у документах більше, ніж каву вранці. Якщо Excel — твій друг, а слова “особова справа” та “наказ” викликають не паніку, а легку професійну радість — тоді тобі до нас.",
            },
            responsibilities: {
                title: "Що ти будеш робити:",
                items: [
                    "Ведення обліку особового складу компанії, підрозділів",
                    "Повний цикл кадрового діловодства згідно законодавства",
                    "Формування і ведення особових справ працівників",
                    "Заповнення, ведення обліку і зберігання трудових книжок",
                    "Ведення обліку надання відпусток працівникам",
                    "Ведення архівів особових справ"
                ]
            },
            requirements: {
                title: "Що нам важливо:",
                items: [
                "Досвід роботи у сфері кадрового діловодства — від 1 року",
                    "Знання трудового законодавства України",
                    "Досвід ведення кадрової документації",
                    "Впевнене володіння Excel та BAF (BAS)",
                    "Уважність до деталей, відповідальність, системне мислення",
                    "Вміння працювати з конфіденційною інформацією, дотримання GDPR/внутрішніх політик",
                    "Знання англійської мови на рівні B1"
                ]
            },
            benefits: {
                title: "Що отримаєш у команді:",
                items: [
                    "Гібридний формат роботи і можливість працювати з дому",
                    "Мінімум бюрократії — максимум свободи",
                    "Умови для професійного розвитку",
                    "Програма бонусів (вивчення мов, спорт, психологічна підтримка тощо)",
                    "Компенсація витрат на навчання",
                    "Медичне страхування"
                ]
            },
            stages: {
                title: "Етапи відбору",
                subtitle: "Інтерв'ю з HR ➡ Тестове завдання ➡ Фінальна співбесіда з CFO ➡ Offer 🎉",
            },
        }
    ],

    jobInfo: {
        title: "Інформація про вакансію",
        date: "Дата",
        dateValue: "22.04.2023",
        location: "Локація",
        locationValue: "Київ, Україна",
        experience: "Досвід",
        experienceValue: "3 роки",
        job: "Назва вакансії",
    },

    contactForm: {
        title: "Зв'яжіться з нами",
        subtitle: "Є питання чи потрібна допомога? Напишіть нам, і наша команда відповість якнайшвидше. Ми тут, щоб допомогти!",
        name: "Повне ім'я",
        email: "Електронна пошта",
        date: "Дата народження",
        subject: "Тема",
        message: "Повідомлення",
        upload: "Завантажити файл",
        submit: "Надіслати",
    },

    footer: {
        description:
            "Ми — професійне рекрутингове агентство, що об'єднує бізнес із найкращими фахівцями. Ми спрощуємо процес найму, гарантуючи ідеальну відповідність для кожної ролі.",
        linksTitle: "Посилання",
        links: {
            home: "Головна",
            expertise: "Наша експертиза",
            about: "Про нас",
            process: "Робочий процес",
            vacancies: "Вакансії",
            reviews: "Відгуки",
        },
        contactsTitle: "Контакти",
    },
};
